
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
       getReporteFinanciero: async function(data) {




      
        var result =  await axios
          ({
            method: 'POST',
            url: this.$store.state.baseapi+"reporte/financiero/",
            //responseType: 'html',
            headers: {
              "Content-Type": "text/html",
              'X-Authorization': 'Bearer ' +this.$store.state.user.token
  
            }
            ,
              data:{
              //QUITAR COMILLAS SOLO EN DATA 
              serie:data.serie,
              secretaria:data.secretaria,
              programa:data.programa,
             
            // estatus:data.estatus, 
          
                
                  
                  
              }
              
            }
            
          )
          .then(
            response => {
           
              //context.commit('SET_USER_DEALS', { deals: response.data.data })
              return response.data;
            },
            err => {
              
              return null;
            }
          );
          return result;
  
  
  
  
  
      },
 getReporteTrimestre: async function(data) {




      
        var result =  await axios
          ({
            method: 'POST',
            url: this.$store.state.baseapi+"reporte/trimestres/",
            //responseType: 'html',
            headers: {
              "Content-Type": "text/html",
              'X-Authorization': 'Bearer ' +this.$store.state.user.token
  
            }
            ,
              data:{
              //QUITAR COMILLAS SOLO EN DATA 
              serie:data.serie,
              secretaria:data.secretaria,
              programa:data.programa,
             
            // estatus:data.estatus, 
          
                
                  
                  
              }
              
            }
            
          )
          .then(
            response => {
           
              //context.commit('SET_USER_DEALS', { deals: response.data.data })
              return response.data;
            },
            err => {
              
              return null;
            }
          );
          return result;
  
  
  
  
  
      },
      
  
  

    }
    
    }